import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const s = a(
  (o, l) => /* @__PURE__ */ e.jsx(
    i,
    {
      ref: l,
      ...o,
      image: (r) => /* @__PURE__ */ e.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...r,
          children: /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M3 7.586V6a5 5 0 1 1 10 0v1.586c0 .905.36 1.774 1 2.414l.586.586a1.414 1.414 0 0 1-1 2.414H10a2 2 0 1 1-4 0H2.414a1.414 1.414 0 0 1-1-2.414L2 10c.64-.64 1-1.509 1-2.414",
              clipRule: "evenodd"
            }
          )
        }
      )
    }
  )
);
s.displayName = "BellIcon";
export {
  s as BellIcon,
  s as default
};
//# sourceMappingURL=index.js.map
